module.exports = __webpack_public_path__ + "static/media/2_pl.d1ab468c.png";